export const vairAggregatesDummyData = {
  aiAnsweredCalls: 2000,
  aiEngagedCalls: 1750,
  appointmentsScheduled: 200,
  appointmentsSchedulingAction: 140,
  appointmentsReschedulingAction: 60,
  unscheduledSchedulingOpportunities: 400,
  recoveredSchedulingOpportunities: 40,
};
